import { render, staticRenderFns } from "./material-list.vue?vue&type=template&id=3f1a8c11&"
import script from "./material-list.vue?vue&type=script&lang=js&"
export * from "./material-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports